package antd.typography

import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.typography(handler: RHandler<InternalTypographyProps>) = child(TypographyComponent::class, handler)
fun RBuilder.text(handler: RHandler<TextProps>) = child(TypographyComponent.Text as ComponentType<TextProps>, jsObject {}, handler)
fun RBuilder.title(handler: RHandler<TitleProps>) = child(TypographyComponent.Title as ComponentType<TitleProps>, jsObject {},handler)
fun RBuilder.paragraph(handler: RHandler<ParagraphProps>) = child(TypographyComponent.Paragraph as ComponentType<ParagraphProps>,jsObject {}, handler)
